<template>
  <div class="admin-container">
    <h1 class="mt-5 mb-4" style="font-family: 'PringleandTweed'">Admin Panel</h1>
    
    <div class="container">
      <div class="card shadow">
        <div class="card-header">
          <h3 class="mb-0">All Users</h3>
          <small class="text-muted">Total: {{ users.length }} users</small>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Grade</th>
                  <th>Age</th>
                  <th>Country</th>
                  <th>Theme</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.id }}</td>
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.grade || '-' }}</td>
                  <td>{{ user.age || '-' }}</td>
                  <td>{{ user.country || '-' }}</td>
                  <td>{{ user.theme || '-' }}</td>
                  <td>
                    <button 
                      class="btn btn-sm btn-primary" 
                      @click="viewUserTimeline(user.id)"
                      title="View Timeline">
                      View Timeline
                    </button>
                  </td>
                </tr>
                <tr v-if="users.length === 0">
                  <td colspan="8" class="text-center text-muted py-4">
                    No users found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      users: [],
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      console.log('Getting users')

      axios.get('/api/users/')
        .then(res => {
          this.users = res.data
          console.log('Users loaded:', res.data)
        })
        .catch(error => {
          console.error('Error fetching users:', error)
        })
    },
    viewUserTimeline(userId) {
      // Navigate to timeline with the user ID as a query parameter
      this.$router.push({ path: '/timeline', query: { userID: userId } })
    }
  }
}
</script>

<style scoped>
  .admin-container {
    padding: 20px;
    min-height: 100vh;
  }

  .card {
    border: none;
    border-radius: 8px;
  }

  .card-header {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    padding: 1rem 1.5rem;
  }

  .table {
    font-size: 0.95rem;
  }

  .table thead th {
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
  }

  .table tbody tr {
    transition: background-color 0.2s;
  }

  .table tbody tr:hover {
    background-color: #f8f9fa;
  }

  .btn-sm {
    padding: 0.25rem 0.75rem;
    font-size: 0.875rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue